declare namespace $ {

	export class $mol_icon_fish extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=fish.view.tree.d.ts.map